export default "__VITE_ASSET__2fda7a74__"